import { isFedRamp } from '@atlassian/atl-context';
import { newIssueViewTransitionLockInStatusResource } from '@atlassian/jira-router-resources-new-issue-view-transition-lock-in-status/src/services/index.tsx';
import { nextBestTaskFeatureResource } from '@atlassian/jira-router-resources-next-best-task/src/services/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export const getLabsResources = () => [
	newIssueViewTransitionLockInStatusResource,
	resourceWithCondition2(() => !isFedRamp(), nextBestTaskFeatureResource),
];
